<template>
  <div class="news-center">
    <div>
      <ul class="news-type">
        <li
          @click="newsType(0)"
          :class="{ active: 0 == type_id }"
        >
          全部
        </li>
        <li
          @click="newsType(item.id)"
          v-for="item in type"
          :key="item.id"
          :class="{ active: item.id == type_id }"
        >
          {{ item.name }}
        </li>
      </ul>
      <!--<div class="news-show">
                <ul ref="newsList">
                    <li @mouseenter="highlight(index)" @mouseleave="recover(index)" v-for="(item,index) in news" :key="item.id">
                        <img :src="url+item.image" alt="">
                        <div class="news-show-text">
                            <h4>{{item.title}}</h4>
                            <span>{{getDate(item.create_time)}}</span>
                            <p v-html="item.content"></p>
                            <div @click="newsDetail(item.id)">查看详情<i class="iconfont icon-yousanjiaoxing"></i></div>
                        </div>
                    </li>
                </ul>
            </div>-->
      <div class="news-swiper-container" ref="newsPages">
        <div class="swiper-wrapper">
          <div  class="swiper-slide swiper-no-swiping news-show">
            <ul>
              <li v-for="(item) in newsArr.data"
                  :key="item.id">
                <img :src="item.image" alt="" />
                <div class="news-show-text">
                  <h4>{{ item.title }}</h4>
                  <span>{{ item.createtime }}</span>
                  <p class="fo
                     nsize" v-html="item.content"></p>
                  <div @click="newsDetail(item.id)">
                    查看详情<i class="iconfont icon-yousanjiaoxing"></i>
                  </div>
                </div>
                <!--
                                <h4>{{item.title}}</h4{>
                                <span>{{getDate(item.date)}}</span>
                                <p v-html="item.content"></p>
                                <div @click="newsDetail(item.id)">查看详情<i class="iconfont icon-yousanjiaoxing"></i></div>
                                -->
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="news-button">
         <i class="iconfont icon-jiantouzuo"  @click="prePage()"></i>{{page}}/{{newsArr.last_page}}<i class="iconfont icon-icon_arrow_right"  @click="nextPage()"></i>
      </div>
      
        <!-- <div class="cases-swiper-pagination"></div> -->
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  name: "NewsCenter",
  props: {
    type: Array,
    news: Array,
  },
  data() {
    return {
      actIndex: 0,
      enterIndex: -1,
      newsData: [],
      newsArr: {},// 获取所有数据
      page:1,//当前页
      type_id:0 ,// 0为全部 
    };
  },
  mounted(){
    this.getNewsList()
  },
  methods: {
    
    getNewsList() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/news",
        { limit:10,page:this.page ,type_id:this.type_id},
        (res) => {
          if (res.code == 1) {
            // console.log(res.data)
            this.newsArr = res.data;
          }
        }
      );
    },
      //上一页
      prePage(){
        if(this.page>1){
          this.page-=1
          this.getNewsList()
          window.scrollTo(0, 0)
        }

      },
      //下一页
      nextPage(){
        if(this.newsArr.data.length>=10){
          this.page+=1
          this.getNewsList()
          window.scrollTo(0, 0)

        }
      },
      //筛选分类
    newsType(id) {
      this.type_id = id
      this.page= 1
      this.getNewsList()
    },
    getDate(time) {
      var date = new Date(time * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      return Y + M + D;
    },
    newsDetail(newsId) {
      let routeUrl = this.$router.resolve("/newsdetail/" + newsId);
      window.open(routeUrl.href, '_blank');
      // this.$router.getMonth("/newsdetail/" + newsId);
    },
    // imgSwiper() {
    //   var swiper = new Swiper(".news-swiper-container", {
    //     slidesPerView: 1,
    //     noSwiping: true,
    //     navigation: {
    //       nextEl: ".news-swiper-button-next",
    //       prevEl: ".news-swiper-button-prev",
    //     },
    //     observer: true, //修改swiper自己或子元素时，自动初始化swiper
    //     observeParents: false, //修改swiper的父元素时，自动初始化swiper
    //     onSlideChangeEnd: function (swiper) {
    //       swiper.update();
    //       mySwiper.startAutoplay();
    //       mySwiper.reLoop();
    //     },
    //   });
    // },
  },
  computed: {
    // pages() {
    //   if (!this.newsData) return;
    //   const pages = [];
    //   this.newsData.forEach((item, index) => {
    //     const page = Math.floor(index / 4);
    //     if (!pages[page]) pages[page] = [];
    //     pages[page].push(item);
    //   });
    //   return pages;
    // },
  },
  watch: {
    // news(newVal) {
    //   this.newsData = newVal;
    // },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varible.styl';
@import '~styles/mixins.styl';

.fonsize >>> * {
  font-size: 12px !important;
  line-height: 2em !important;
  text-indent: 0 !important;
}

.news-center >>> .swiper-button-disabled {
  color: #999 !important;
}

.news-center {
  width: 100%;
  margin: 0 auto;
  background: #ddd;
  padding: 5% 0;

  >div {
    width: 66%;
    max-width: 1268px;
    min-width: 1100px;
    margin: 0 auto;
    text-align: center;

    h2 {
      font-size: 42px;
      position: relative;
      margin: 0 0 8%;
      font-weight: 600;
      color: #333;
      letter-spacing: 2px;

      &:after {
        content: '';
        position: absolute;
        margin-left: -0.83em;
        display: block;
        border-bottom: 1px solid #333;
        width: 1.66em;
        margin-top: 40px;
        left: 50%;
      }
    }

    .news-type {
      text-align: center;

      li {
        display: inline-block;
        width: 12%;
        line-height: 3.6em;
        font-size: 14px;
        cursor: pointer;
        margin-right: 1.4%;
        color: #333;
        border-radius: 2px;
        background: #fff;
      }
      li:hover{
        color: #fff;
        background: $black;
      }

      .active {
        color: #fff;
        background: $black;
      }
    }

    .news-swiper-container {
      overflow: hidden;

      .news-show {
        text-align: left;
        width: 100%;
        margin-top: 4%;

        li {
          width: 100%;
          margin-bottom: 2%;
          background: #fff;

          img {
            width: 40%;
            vertical-align: middle;
          }

          .news-show-text {
            float: right;
            box-sizing: border-box;
            width: 60%;
            padding: 2% 6% 0 4%;

            h4 {
              font-size: 22px;
              font-weight: 600;
              line-height: 40px;
              color: #000;
              margin-bottom: 14px;
              max-height: 80px;
            }

            span {
              color: #999;
            }

            >p {
              margin-top: 18px;
              text-ellipsis();
              line-height: 24px;
              font-size: 14px;
              height: 48px;
            }

            >div {
              cursor: pointer;
              margin-top: 1.4em;
              float: left;
              border-radius: 20px;
              line-height: 34px;
              border: 1px solid #333;
              color: #333;
              font-size: 14px;
              width: 117px;
              text-align: center;

              i {
                margin-left: 7px;
                font-size: 12px;
                line-height: 1em;
                vertical-align: inherit;
              }
            }

            .highlight {
              background: $yellow;
              color: #fff;
              border: 1px solid $yellow;
            }
          }
        }
      }
    }

    .news-button {
      display: inline-block;
      margin: 2em auto;
      font-size: 14px;
      background: #000;
      line-height: 3.4em;
      color :#fff;

      i {
        color: #fff;
        padding: 0 2.5em;
        font-size: 12px;
        cursor: pointer;
        outline: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/NewsCenter.vue